$(document).ready(function () {
  $("li.dropdown.menuitem.dropdown-pers").focusout(function () {
    $("li.dropdown.menuitem.dropdown-pers").removeClass("dropdown-pers-focusin");
    $("li.dropdown.menuitem.dropdown-pers").addClass("dropdown-pers-focusout");
  });

  $("li.dropdown.menuitem.dropdown-pers").focusin(function () {
    $("li.dropdown.menuitem.dropdown-pers").removeClass("dropdown-pers-focusout");
    $("li.dropdown.menuitem.dropdown-pers").addClass("dropdown-pers-focusin");
  });

  $(".menuitem.redesign-search").keypress(function () {
    if ($("nav.navbar.menu-redesign").hasClass("search-open")) {
      $("#search-collapsible").prop("checked", false);
      $("nav.navbar.menu-redesign").removeClass("search-open");
    } else {
      $("#search-collapsible").prop("checked", true);
      $("nav.navbar.menu-redesign").addClass("search-open");
    }
  });
});

// menu-redesign
$('#fon-menu .menuitem', '.menu-redesign').click(showMenuSpinner);
// menu-profi
$('.navbar-header .navbar-brand', '.menu-profi').click(showMenuSpinner);
$('.navbar-nav > li', '.menu-profi').not('.dropdown').click(showMenuSpinner);
$('li.dropdown .dropdown-menu li', '.menu-profi').click(showMenuSpinner);

function showMenuSpinner() {
  $('html, body').animate({ scrollTop: $('a[href="#content"]').offset().top }, 'fast');
  $('.header-spinner').show();
}